import { CalculatedConsumablesDemandThemeModeConfig } from './types';

const light: CalculatedConsumablesDemandThemeModeConfig = {
  calculatedConsumablesDemand: {},
};

export default light;
